import { Handle, Position, NodeProps } from '@xyflow/react';
import { FlowNodeType, FlowNodeTypeValue } from '../types';
import { getNodeInfo } from '../metadata';

interface TriggerNodeData {
  type: FlowNodeTypeValue;
  config: string;
  [key: string]: unknown;
}

export function TriggerNode({ data, selected }: NodeProps) {
  const d = data as TriggerNodeData;
  const info = getNodeInfo(d.type);
  const preview = getPreview(d);

  return (
    <div
      className="wt-rf-node"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: info.color }}
    >
      <div className="wt-rf-node-head" style={{ color: info.color }}>
        <span className="wt-rf-node-dot" style={{ background: info.color }} />
        <span>{info.label}</span>
      </div>
      <div className="wt-rf-node-preview">{preview}</div>
      <Handle type="source" position={Position.Bottom} className="wt-rf-port" />
    </div>
  );
}

function getPreview(data: TriggerNodeData): string {
  if (data.type === FlowNodeType.TriggerNewConversation) {
    return 'Dispara em nova conversa';
  }
  if (data.type === FlowNodeType.TriggerKeyword) {
    try {
      const cfg = JSON.parse(data.config || '{}');
      const keywords: string[] = cfg.keywords ?? [];
      return keywords.length === 0 ? '(sem palavras-chave)' : keywords.join(', ');
    } catch {
      return '(config inválida)';
    }
  }
  return '';
}
